import {useResources} from '@/di/di.root-container.hooks';

import Div100vh from 'react-div-100vh';

import {useObservedFreeGameStore} from '@/stores/connectors';
import {KeyVisual} from '@/ui/components/KeyVisual/KeyVisual';
import {Image} from '@/ui/kit/Image/Image';
import {Preloader} from '@/ui/kit/Preloader/Preloader';

import s from './LoaderPageMb.module.css';

type LoaderPageMbProps = {
  hidden?: boolean;
};

export function LoaderPageMb({hidden = false}: LoaderPageMbProps): JSX.Element {
  const {
    content: {
      LoaderPage: {image},
      mainPage: {
        freeGame: {loaderImage},
      },
    },
  } = useResources();

  const freeGamesStore = useObservedFreeGameStore();
  const isActiveFreeGames = freeGamesStore.isActiveFreeGames();

  const imageSrc = isActiveFreeGames ? loaderImage.src : image.src;
  const imageAlt = isActiveFreeGames ? loaderImage.alt : image.alt;

  return (
    <Div100vh className={s.wrapper} hidden={hidden}>
      <div className={s.preloaderContainer}>
        <KeyVisual />
        <div className={s.preloaderWrapper}>
          <Preloader className={s.preloader} circleClassName={s.preloaderCircle} />
        </div>
        <Image className={s.loaderImage} pictureClassName={s.loaderImageWrapper} src={imageSrc} alt={imageAlt} />
      </div>
    </Div100vh>
  );
}
